import firebase from '../config/fbConfig'
import moment from 'moment'
import 'moment/locale/es'
import { getReduceFormattedData } from '../helpers';

// Get data user
export const  getDataUserDB = async () => {
    try {
        
        const user = await firebase.auth().currentUser;

        if(user && user.uid) {

            const response = await firebase.firestore().collection('users').doc(user.uid).get()

            if(response.exists) {
                return {
                    result: response.data()
                }
            } else {
                return {
                    result: {
                        empty: true
                    }
                }
            }

        }

    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Get cookies user
export const getCookiesUserDB = async () => {
    try {
        
        const user = await firebase.auth().currentUser;
        if(user && user.uid) {

            const today = new Date();
            const last30Days = new Date(new Date().setDate(today.getDate() - 30))


            const cookiesDB = await firebase.firestore().collection('cookies').where('user_id', '==', user.uid).where('created_at', '>=', last30Days).get();
            if(cookiesDB.docs.length > 0) {

                const formattedDataCookies = cookiesDB.docs.map(cookie => {
                    return {
                        ...cookie.data(),
                        created_at_formmatted: moment(new Date(cookie.data().created_at.seconds * 1000)).format("Do MMM"), 
                        id: cookie.id
                    }
                })

                const reducedData = getReduceFormattedData(formattedDataCookies)

                return {
                    result: reducedData
                }

            }

        }

    } catch (error) {
        console.error(error);
        return {
            error
        }
    }
}

// Creamos las preferencias del usuario
export const createPreferencesFB = async ({genre, profession, adblocker, birthday, type_ads, phone}) => {       
    
    try {
        const user = await firebase.auth().currentUser;

        if(user && user.uid) {

            // Damos al usuario 10 puntos por registrarse
            await firebase.firestore().collection('preferences').add({
                user_id: user.uid,
                genre: genre || null,
                profession: profession || null,
                adblocker: adblocker || null,
                birthday: firebase.firestore.Timestamp.fromDate(new Date(birthday)) || null,
                phone,
                id_ads: type_ads || [],
                income: null,
                created_at: firebase.firestore.FieldValue.serverTimestamp()
            });

            await firebase.firestore().collection('users').doc(user.uid).set({
                shield_points: [{
                    points: 10,
                    created_at: new Date()
                }]
            }, {merge: true})

            return {
                result: true
            }

        }
    } catch (error) {
        console.error(error);
        return {error}
    }
    
}

// Function to get balance of two last weeks
export const getShieldPointsTwoLastWeeks = async () => {
    try {
        
        const user = await firebase.auth().currentUser;

        if(user && user.uid) {

            const shieldPointsQuery = await firebase.firestore().collection('shield_points').where('user_id', '==', user.uid).get();
            if(shieldPointsQuery.docs.length > 0) {

                const shieldPoints = shieldPointsQuery.docs.map(shieldPoint => {
                    return {
                        ...shieldPoint.data(),
                        id: shieldPoint.id
                    }
                })

                const shieldPointsSortedByDate = shieldPoints.sort(function(a, b) {
                    return a.created_at.seconds - b.created_at.seconds
                })

                const shieldPointsOfTwoLastWeeks = shieldPointsSortedByDate.slice(shieldPointsSortedByDate.length - 12)

                const formattedShieldPoints = shieldPointsOfTwoLastWeeks.map(sp => {
                    let date = moment(new Date(sp.created_at.seconds * 1000)).format("Do MMM");
                    return {
                        name: date,
                        points: sp.shield_points
                    }
                });

                return {
                    result: formattedShieldPoints
                }

            }

        }

    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Get user shield tokens
export const getUserShieldTokens = async () => {
    try {
        
        const user = await firebase.auth().currentUser;
        if(user && user.uid) {

            const shieldPointsDB = await firebase.firestore().collection('shield_points').orderBy('created_at', 'desc').where('user_id', '==', user.uid).get();
            if(shieldPointsDB.docs.length > 0) {

                return {
                    result: shieldPointsDB.docs[0].data()
                }
            } else {
                return {
                    empty: true
                }
            }

        }

    } catch (error) {
        console.error(error);
        return {
            error
        }
    }
}

// Funcion para obtener el balance de las 2 ultimas semanas de un usuario
export const getTwoLastWeeksFB = async () => {
    try {
        
        const user = await firebase.auth().currentUser

        if(user && user.uid) {

            const dataAux = [];

            const data = await firebase.firestore().collection('users').doc(user.uid).get()

            // Obtenemos la informacion de las dos ultimas semanas
            const newArrayPoint = data.data().shield_points.slice(data.data().shield_points.length - 12);

            for (const doc of newArrayPoint) {

                let date = moment(new Date(doc.created_at.seconds * 1000)).format("Do MMM")
                dataAux.push({
                    name: date,
                    points: doc.points
                })

            }

            return {
                result: dataAux
            }

        }

    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Function to get ads of user
export const getUserPreferencesAdsDB = async () => {
    try {
        
        const user = await firebase.auth().currentUser;
        let result = {}

        if(user && user.uid) {

            // Obtenemos las preferencias
            const dataPref = await firebase.firestore().collection('preferences').where('user_id', '==', user.uid).get();

            // Obtenemos los anuncios
            if(dataPref.docs.length > 0) {
                const { id_ads } = dataPref.docs[0].data();
                const dataAds = id_ads.map(async (ia) => {
                    const response = await firebase.firestore().collection('ads').doc(ia).get()
                    return {...response.data(), id: response.id}
                })

                const responseAds = await Promise.all(dataAds);

                const { adblocker, birthday, genre, profession, phone} = dataPref.docs[0].data()
                result = {
                    adblocker,
                    birthday,
                    genre,
                    phone: phone || null,
                    profession,
                    ads: [...responseAds],
                    id: dataPref.docs[0].id,
                    income: dataPref.docs[0].data().income || null,
                    email: user.email
                }
                
                return {
                    result
                }
            }else {
                return {
                    empty: true
                }
            }
        }

    } catch (error) {
        console.error(error);
        return {
            error
        }
    }
}


// Funcion para obtener las preferencias de un usuario
export const getUserPreferences = async () => {
    try {
        
        const user = await firebase.auth().currentUser;
        if(user && user.uid) {

            const preferences = await firebase.firestore().collection('preferences').where('user_id', '==', user.uid).get();
            if(preferences.docs.length > 0) {
                return {
                    result: preferences.docs[0].data()
                }
            } else {
                return {
                    result: {
                        empty: true
                    }
                }
            }

        }

    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Funcion para guardar la wallet del usuario
export const saveWalletOfUser = async (wallet_address) => {
    try {
        
        const user = await firebase.auth().currentUser;
        if(user && user.uid) {
            await firebase.firestore().collection('users').doc(user.uid).set({
                user_wallet: wallet_address,
                updated_at: firebase.firestore.FieldValue.serverTimestamp()
            }, {merge: true })


            return {
                result: true
            }
        } 

    } catch (error) {
        console.error(error);
        return {error}
    }
}

// Funcion para obtener los anuncios de las preferencias
export const getAdsShield = async () => {
    try {
        
        const response = await firebase.firestore().collection('ads').get();
        const ads = response.docs.map(ad => {
            return {
                ...ad.data(),
                id: ad.id
            }
        })

        return {
            result: ads
        }

    } catch (error) { 
    }
}

// Function to get preferences privacy
export const getAllPreferencesPrivacy = async () => {
    try {
        
        const preferencesQuery = await firebase.firestore().collection('preferences_privacity').get();
        if(preferencesQuery.docs.length > 0) {
            const preferences = preferencesQuery.docs.map(prefs => {
                return {
                    ...prefs.data(),
                    id: prefs.id
                }
            })

            return {
                result: preferences
            }
        }

    } catch (error) {
        console.error(error)
        return {
            error
        }
    }
}

// Get user profile
export const getDataProfileFB = async () => {
    try {
        
        const user = await firebase.auth().currentUser;

        if(user && user.uid) {
            const userQuery = await firebase.firestore().collection('users').doc(user.uid).get()
            if(userQuery.exists) {
                return {
                    result: userQuery.data()
                }
            } else {
                return {
                    empty: true
                }
            }

        }

    } catch (error) {
        console.error(error)
        return {
            error
        }
    }
}

// Update privacy user preferences
export const updatePrivacyUserPreferences = async privacyPrefs => {
    try {
        
        const user = await firebase.auth().currentUser;

        await firebase.firestore().collection('users').doc(user.uid).set({
            preferences_privacity: privacyPrefs
        }, {merge: true})

    } catch (error) {
        console.error(error)
        return {
            error
        }
    }
}

export const logout = async () => {
    try {
        
        await firebase.auth().signOut()

    } catch (error) {
        console.error(error);
        return {
            error
        }
    }
}